/**
 * Created by nijin on 28/3/17.
 */
import {Directive, HostListener, ElementRef, AfterContentInit, Optional} from "@angular/core";
import {NgControl} from "@angular/forms";
import {isUndefined} from "util";
@Directive({
  selector:'.form-control',

})

export class FormControl implements AfterContentInit{

  private value;

  constructor(private elem: ElementRef, @Optional() public _ngControl: NgControl){

  }

  @HostListener('blur', ['$event']) focusOut(){
    if (this.value === null || isUndefined(this.value) ){
      return;
    }
    this.value.toString().length > 0 ? this.elem.nativeElement.parentNode.classList.add('floatLabel')
      : this.elem.nativeElement.parentNode.classList.remove('floatLabel');
  }

  @HostListener('focus', ['$event']) addClassOnFocus(){
    this.elem.nativeElement.parentNode.classList.add('floatLabel');
  }



ngAfterContentInit() {
  this.value = this.elem.nativeElement.value;
   if (this._ngControl && this._ngControl.valueChanges) {
    this._ngControl.valueChanges.subscribe(value => {this.value = value; this.addFloatClass()});
      }
   if(this.value && this.value.length){
    this.elem.nativeElement.parentNode.classList.add('floatLabel');
   }
}

private addFloatClass(){
    if(!this.elem.nativeElement.parentNode){
      return ;
    }

  if((this.value === null || isUndefined(this.value) )){
    this.elem.nativeElement.parentNode.classList.remove('floatLabel');
    return;
  }
  if(this.elem.nativeElement && this.elem.nativeElement.parentNode){
    this.elem.nativeElement.parentNode.classList.add('floatLabel');
  }

}


}



// WEBPACK FOOTER //
// ./src/app/shared/form/form.control.ts